<template>
  <div>
    <a class="item-share" @click.prevent="share">
      <i class="icon-share" />
    </a>
    <ShareModal v-if="isMobile" :is-open="isOpen" :link="link" @close-self="closeSelf" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import $ from 'jquery';

import useSetEnv from '@global/composable/useSetEnv';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';

import ShareModal from '@components/ShareModal.vue';

const { setEnv } = useSetEnv();
const { getShareAPI } = useAxiosAPI();
const modalStore = useModalStore();
const { openModal } = modalStore;

const isOpen = ref(false);
const link = ref('');

const props = defineProps({
  marketId: {
    type: Number,
    required: true,
  },
});

const isMobile = setEnv.myEquipment();

function share() {
  getShareAPI(props.marketId)
    .then((res) => {
      if (res.data.Code === 200) {
        link.value = res.data.Response.Link;
        if (!isMobile) {
          openModal('ShareModal', link.value);
        } else {
          isOpen.value = true;
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function closeSelf() {
  link.value = '';
  if (isMobile) {
    isOpen.value = false;
  }
}
</script>
